/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as moment from 'moment';

export class Statistics {
  // Reports engaged and dollar and average dollar amount amount this week M-Fr
  ENGAGED_THIS_WEEK: StatisticsValueSummary;

  // Reports engaged and dollar amount and average dollar amount last week M-Fr
  ENGAGED_LAST_WEEK: StatisticsValueSummary;

  // Number and dollar amount of Reports in these stages [ORDR, FBRI, ELST]
  IN_STAGES: StatisticsValueSummary;

  // Reports on Hold
  //IN_HOLD: StatisticsValueSummary;
  IN_HOLD: number;

  //Current Quarter
  //Total Number of Reports in current quarter
  CURRENT_QUARTER: number;

  //Completed Reports - (half or zero)
  COMPLETED: number;

  //Stage = QUOT
  QUOTED_THIS_WEEK: number;

  // Stage = SBMT
  COMPLETED_THIS_WEEK: number;
  COMPLETED_LAST_WEEK: number;

  // Number of Report currently in Stage Engaged through Submit Report (currently being worked on)
  IN_PROCESSING: number;
  // Number of Report current in Due Today
  DUE_TODAY: number;
  PAST_DUE: number;

  ENGAGED_THIS_QUARTER: number;
  GOAL_THIS_QUARTER: number;

  // Dates
  THIS_WEEK_BEG: string;
  THIS_WEEK_END: string;
  LAST_WEEK_BEG: string;
  LAST_WEEK_END: string;

  // Order Recived this week M-Fr
  ORDER_RECEIVED_THIS_WEEK: number;
  // Order Recived lastk  week M-Fr
  ORDER_RECEIVED_LAST_WEEK: number;

  //Computation of days when Reports get Completed, from Report Created to Report Completed.
  COMPLETION_TIME_LAST_WEEK: StatisticsValueSummary;
  COMPLETION_TIME_LAST_MONTH: StatisticsValueSummary;
  COMPLETION_TIME_CURRENT_QUARTER: StatisticsValueSummary;

  // Stage = R1DR
  FIRST_DRAFT_THIS_WEEK: number;
  FIRST_DRAFT_LAST_WEEK: number;

  //Stage = SPRE
  SUPPLEMENTAL_RECEIVED_THIS_WEEK: number;

  // Goal data
  GOAL_THIS_WEEK: GoalData;
  GOAL_LAST_WEEK: GoalData;

  constructor(value: any = {}) {
    Object.assign(this, value);

    if(value.ENGAGED_THIS_WEEK){
      this.ENGAGED_THIS_WEEK = new StatisticsValueSummary(value.ENGAGED_THIS_WEEK);
    }

    if (value.ENGAGED_LAST_WEEK) {
      this.ENGAGED_LAST_WEEK = new StatisticsValueSummary(value.ENGAGED_LAST_WEEK);
    }

    if (value.IN_STAGES){
      this.IN_STAGES = new StatisticsValueSummary(value.IN_STAGES);
    }

    if (value.COMPLETION_TIME_LAST_WEEK)
      this.COMPLETION_TIME_LAST_WEEK = new StatisticsValueSummary(value.COMPLETION_TIME_LAST_WEEK);

    if (value.COMPLETION_TIME_LAST_MONTH)
      this.COMPLETION_TIME_LAST_MONTH = new StatisticsValueSummary(value.COMPLETION_TIME_LAST_MONTH);

    if (value.COMPLETION_TIME_CURRENT_QUARTER)
      this.COMPLETION_TIME_CURRENT_QUARTER = new StatisticsValueSummary(value.COMPLETION_TIME_CURRENT_QUARTER);

    if (value.GOAL_THIS_WEEK)
      this.GOAL_THIS_WEEK = new GoalData(value.GOAL_THIS_WEEK);

    if (value.GOAL_LAST_WEEK)
      this.GOAL_LAST_WEEK = new GoalData(value.GOAL_LAST_WEEK);
  }

}

export class StatisticsValueSummary {
  COUNT: number;
  VALUE: number;
  VALUE_AVG: number;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }
}

export class GoalData {
  GOAL_TYPE: GoalType;
  GOAL_REPORTS: number;
  GOAL_AVG: number;
  GOAL_TOTAL: number;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }
}

export enum GoalType{
  QUARTERLY = 'QUARTERLY',
  WEEKLY = 'WEEKLY'
}

export class StatisticsChart {
  INDEX: number;
  VALUE: number;
  DATE: Date;
}

export class StatisticsChartData{
  HISTORIC: ChartData[] = [];
  CURRENT: ChartData[] = [];
  PREDICTED: ChartData[] = [];

  static parse(json: any): StatisticsChartData {
    if (json) {
      const f = new StatisticsChartData();
      if(json.HISTORIC)
        f.HISTORIC = ChartData.parseArray(json.HISTORIC);

      if (json.CURRENT)
        f.CURRENT = ChartData.parseArray(json.CURRENT);

      if(json.PREDICTED)
        f.PREDICTED = ChartData.parseArray(json.PREDICTED);

      return f;
    } else return null;
  }

  static parseArray(json: any[]): StatisticsChartData[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(StatisticsChartData.parse(j));
        }
      }
    }

    return arr;
  }
}

export class ChartData{
  VALUE: number;
  WEEK: number;
  DATE: Date;

  static parse(json: any): ChartData {
    if (json) {
      const f = new ChartData();

      f.VALUE = json.VALUE;
      f.WEEK = json.WEEK;
      f.DATE = json.DATE;

      return f;
    } else return null;
  }

  static parseArray(json: any[]): ChartData[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(ChartData.parse(j));
        }
      }
    }

    return arr;
  }
}
